import React from 'react';
import { ArrowUpRight, Mail, MessageCircle } from 'lucide-react';
import { companyInfo } from '../mock';

const ContactCards = ({ whatsappHref, mailHref }) => {
  return (
    <div className="grid md:grid-cols-2 gap-5 lg:gap-6 h-full">
      {/* WhatsApp Card */}
      <a
        href={whatsappHref}
        target="_blank"
        rel="noreferrer"
        className="card-lift group relative overflow-hidden flex flex-col justify-between p-8 md:p-10 rounded-sm bg-[#0f0d0b] text-white min-h-[340px]"
      >
        <div>
          <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center">
            <MessageCircle size={22} />
          </div>
          <div className="mt-8 text-[11px] tracking-[0.28em] uppercase text-[#B8935A]">Fastest reply</div>
          <h3 className="mt-2 font-serif text-3xl md:text-[34px] leading-[1.1]">WhatsApp</h3>
          <p className="mt-4 text-white/75 text-[14.5px] leading-relaxed">
            Send a photo, sketch or a quick question. We usually reply within one business day.
          </p>
        </div>
        <div className="mt-8 flex items-center justify-between">
          <span className="text-white/90 text-[15px] font-medium">{companyInfo.phone2}</span>
          <span className="w-11 h-11 rounded-full border border-white/40 flex items-center justify-center group-hover:bg-[#25D366] group-hover:border-[#25D366] transition-all">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </a>

      {/* Email Card */}
      <a
        href={mailHref}
        className="card-lift group relative overflow-hidden flex flex-col justify-between p-8 md:p-10 rounded-sm bg-white text-[#1a1a1a] border border-[#E5DED0] min-h-[340px]"
      >
        <div>
          <div className="w-14 h-14 rounded-full bg-[#7B1E24] flex items-center justify-center text-white">
            <Mail size={22} />
          </div>
          <div className="mt-8 text-[11px] tracking-[0.28em] uppercase text-[#B8935A]">For detailed briefs</div>
          <h3 className="mt-2 font-serif text-3xl md:text-[34px] leading-[1.1]">Email</h3>
          <p className="mt-4 text-[#4a463f] text-[14.5px] leading-relaxed">
            Send drawings, tender documents or a detailed scope. We endeavour to reply within one business day.
          </p>
        </div>
        <div className="mt-8 flex items-center justify-between gap-3">
          <span className="text-[#1a1a1a] text-[15px] font-medium truncate">{companyInfo.email}</span>
          <span className="w-11 h-11 rounded-full border border-[#1a1a1a]/30 flex items-center justify-center group-hover:bg-[#7B1E24] group-hover:text-white group-hover:border-[#7B1E24] transition-all flex-shrink-0">
            <ArrowUpRight size={16} />
          </span>
        </div>
      </a>

      {/* Careers strip */}
      <div className="md:col-span-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 p-6 md:p-7 rounded-sm bg-white border border-[#E5DED0]">
        <div>
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#B8935A]">Careers</div>
          <div className="mt-1 font-serif text-lg md:text-xl text-[#1a1a1a]">Join the Cherry Stone team</div>
        </div>
        <a
          href={`mailto:${companyInfo.hrEmail}`}
          className="inline-flex items-center gap-2 text-[#7B1E24] hover:text-[#5C1319] text-sm transition-colors"
        >
          {companyInfo.hrEmail} <ArrowUpRight size={14} />
        </a>
      </div>
    </div>
  );
};

export default ContactCards;
